// data/whoamiPeople.js
export const whoamiPeople = [
  {
    "item": "http://www.wikidata.org/entity/Q8479",
    "itemLabel": "Pierre Ier de Russie",
    "birthDate": "1672-06-09T00:00:00Z",
    "deathDate": "1725-02-08T00:00:00Z",
    "description": "tsar puis empereur de Russie, de 1682 à 1725",
    "countryLabel": "Empire russe",
    "sitelinks": "178"
  },
  {
    "item": "http://www.wikidata.org/entity/Q22670",
    "itemLabel": "Friedrich Schiller",
    "birthDate": "1759-11-10T00:00:00Z",
    "deathDate": "1805-05-09T00:00:00Z",
    "description": "poète, dramaturge, esthète et historien allemand",
    "countryLabel": "duché de Wurtemberg",
    "sitelinks": "180"
  },
  {
    "item": "http://www.wikidata.org/entity/Q11812",
    "itemLabel": "Thomas Jefferson",
    "birthDate": "1743-04-13T00:00:00Z",
    "deathDate": "1826-07-04T00:00:00Z",
    "description": "philosophe politique, diplomate, architecte et homme d'État américain",
    "countryLabel": "États-Unis",
    "sitelinks": "221"
  },
  {
    "item": "http://www.wikidata.org/entity/Q36322",
    "itemLabel": "Jane Austen",
    "birthDate": "1775-12-16T00:00:00Z",
    "deathDate": "1817-07-18T00:00:00Z",
    "description": "romancière et femme de lettres anglaise",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "196"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7322",
    "itemLabel": "Christophe Colomb",
    "birthDate": "1451-01-01T00:00:00Z",
    "deathDate": "1506-05-30T00:00:00Z",
    "description": "navigateur et explorateur italien, XVe et début du XVIe siècle",
    "countryLabel": "république de Gênes",
    "sitelinks": "240"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5597",
    "itemLabel": "Raphaël",
    "birthDate": "1483-04-06T00:00:00Z",
    "deathDate": "1520-04-16T00:00:00Z",
    "description": "peintre et architecte italien de la Renaissance (1483–1520)",
    "countryLabel": "Saint-Empire romain germanique",
    "sitelinks": "189"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5580",
    "itemLabel": "Albrecht Dürer",
    "birthDate": "1471-05-30T00:00:00Z",
    "deathDate": "1528-04-16T00:00:00Z",
    "description": "peintre, graveur et mathématicien allemand (1471–1528)",
    "countryLabel": "duché de Bavière",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q6527",
    "itemLabel": "Jean-Jacques Rousseau",
    "birthDate": "1712-06-28T00:00:00Z",
    "deathDate": "1778-07-02T00:00:00Z",
    "description": "écrivain, philosophe et musicien genevois",
    "countryLabel": "république de Genève",
    "sitelinks": "227"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7604",
    "itemLabel": "Leonhard Euler",
    "birthDate": "1707-04-15T00:00:00Z",
    "deathDate": "1783-09-18T00:00:00Z",
    "description": "mathématicien, physicien, ingénieur et philosophe suisse (1707-1783)",
    "countryLabel": "royaume de Prusse",
    "sitelinks": "185"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8605",
    "itemLabel": "Simón Bolívar",
    "birthDate": "1783-07-24T00:00:00Z",
    "deathDate": "1830-12-17T00:00:00Z",
    "description": "militaire et homme d'État vénézuélien",
    "countryLabel": "Équateur",
    "sitelinks": "173"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8605",
    "itemLabel": "Simón Bolívar",
    "birthDate": "1783-07-24T00:00:00Z",
    "deathDate": "1830-12-17T00:00:00Z",
    "description": "militaire et homme d'État vénézuélien",
    "countryLabel": "Bolivie",
    "sitelinks": "173"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8605",
    "itemLabel": "Simón Bolívar",
    "birthDate": "1783-07-24T00:00:00Z",
    "deathDate": "1830-12-17T00:00:00Z",
    "description": "militaire et homme d'État vénézuélien",
    "countryLabel": "Espagne",
    "sitelinks": "173"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8605",
    "itemLabel": "Simón Bolívar",
    "birthDate": "1783-07-24T00:00:00Z",
    "deathDate": "1830-12-17T00:00:00Z",
    "description": "militaire et homme d'État vénézuélien",
    "countryLabel": "Venezuela",
    "sitelinks": "173"
  },
  {
    "item": "http://www.wikidata.org/entity/Q35802",
    "itemLabel": "Baruch Spinoza",
    "birthDate": "1632-11-24T00:00:00Z",
    "deathDate": "1677-02-21T00:00:00Z",
    "description": "philosophe néerlandais du XVIIe siècle",
    "countryLabel": "Provinces-Unies",
    "sitelinks": "176"
  },
  {
    "item": "http://www.wikidata.org/entity/Q687",
    "itemLabel": "Molière",
    "birthDate": "1622-01-15T00:00:00Z",
    "deathDate": "1673-02-17T00:00:00Z",
    "description": "auteur et homme de théâtre français",
    "countryLabel": "royaume de France",
    "sitelinks": "220"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9554",
    "itemLabel": "Martin Luther",
    "birthDate": "1483-11-19T00:00:00Z",
    "deathDate": "1546-02-28T00:00:00Z",
    "description": "théologien allemand, père du protestantisme",
    "countryLabel": "Saint-Empire romain germanique",
    "sitelinks": "253"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8963",
    "itemLabel": "Johannes Kepler",
    "birthDate": "1572-01-06T00:00:00Z",
    "deathDate": "1630-11-15T00:00:00Z",
    "description": "astronome allemand",
    "countryLabel": "duché de Wurtemberg",
    "sitelinks": "181"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5682",
    "itemLabel": "Miguel de Cervantes",
    "birthDate": "1547-10-09T00:00:00Z",
    "deathDate": "1616-04-22T00:00:00Z",
    "description": "romancier, poète et dramaturge espagnol",
    "countryLabel": "couronne de Castille",
    "sitelinks": "241"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5586",
    "itemLabel": "Hokusai",
    "birthDate": "1760-10-31T00:00:00Z",
    "deathDate": "1849-05-10T00:00:00Z",
    "description": "peintre, dessinateur et graveur japonais (1760-1849)",
    "countryLabel": "Japon",
    "sitelinks": "172"
  },
  {
    "item": "http://www.wikidata.org/entity/Q935",
    "itemLabel": "Isaac Newton",
    "birthDate": "1643-01-04T00:00:00Z",
    "deathDate": "1727-03-31T00:00:00Z",
    "description": "philosophe, mathématicien, physicien, alchimiste, astronome et théologien anglais",
    "countryLabel": "royaume d'Angleterre",
    "sitelinks": "303"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5432",
    "itemLabel": "Francisco de Goya",
    "birthDate": "1746-03-30T00:00:00Z",
    "deathDate": "1828-04-16T00:00:00Z",
    "description": "peintre et graveur espagnol (1746-1828)",
    "countryLabel": "Espagne",
    "sitelinks": "179"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5598",
    "itemLabel": "Rembrandt",
    "birthDate": "1606-07-15T00:00:00Z",
    "deathDate": "1669-10-04T00:00:00Z",
    "description": "peintre et graveur néerlandais (1606–1669)",
    "countryLabel": "Provinces-Unies",
    "sitelinks": "201"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7226",
    "itemLabel": "Jeanne d'Arc",
    "birthDate": "1412-01-01T00:00:00Z",
    "deathDate": "1431-06-08T00:00:00Z",
    "description": "sainte catholique et héroïne de l'histoire de France (1412-1431)",
    "countryLabel": "royaume de France",
    "sitelinks": "187"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9047",
    "itemLabel": "Gottfried Wilhelm Leibniz",
    "birthDate": "1646-07-01T00:00:00Z",
    "deathDate": "1716-11-14T00:00:00Z",
    "description": "philosophe, mathématicien et scientifique allemand",
    "countryLabel": "électorat de Saxe",
    "sitelinks": "203"
  },
  {
    "item": "http://www.wikidata.org/entity/Q34969",
    "itemLabel": "Benjamin Franklin",
    "birthDate": "1706-01-17T00:00:00Z",
    "deathDate": "1790-04-17T00:00:00Z",
    "description": "père fondateur des États-Unis d'Amérique, politicien, écrivain, philosophe, physicien, publiciste et imprimeur américain",
    "countryLabel": "États-Unis",
    "sitelinks": "215"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5679",
    "itemLabel": "Lord Byron",
    "birthDate": "1788-01-22T00:00:00Z",
    "deathDate": "1824-04-19T00:00:00Z",
    "description": "poète britannique",
    "countryLabel": "royaume de Grande-Bretagne",
    "sitelinks": "214"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1496",
    "itemLabel": "Fernand de Magellan",
    "birthDate": "1480-01-01T00:00:00Z",
    "deathDate": "1521-05-07T00:00:00Z",
    "description": "navigateur et explorateur portugais au service de l'Espagne, fin du XVe - début du XVIe siècle",
    "countryLabel": "royaume de Portugal",
    "sitelinks": "192"
  },
  {
    "item": "http://www.wikidata.org/entity/Q254",
    "itemLabel": "Wolfgang Amadeus Mozart",
    "birthDate": "1756-01-27T00:00:00Z",
    "deathDate": "1791-12-05T00:00:00Z",
    "description": "compositeur, pianiste, violoniste, organiste et chef d'orchestre autrichien",
    "countryLabel": "principauté archiépiscopale de Salzbourg",
    "sitelinks": "267"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1043",
    "itemLabel": "Carl von Linné",
    "birthDate": "1707-05-23T00:00:00Z",
    "deathDate": "1778-01-10T00:00:00Z",
    "description": "naturaliste suédois (1707-1778)",
    "countryLabel": "Suède",
    "sitelinks": "209"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9353",
    "itemLabel": "John Locke",
    "birthDate": "1632-09-08T00:00:00Z",
    "deathDate": "1704-11-08T00:00:00Z",
    "description": "philosophe anglais",
    "countryLabel": "royaume d'Angleterre",
    "sitelinks": "204"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5676",
    "itemLabel": "Matsuo Bashō",
    "birthDate": "1644-01-01T00:00:00Z",
    "deathDate": "1694-11-28T00:00:00Z",
    "description": "poète japonais (1644-1694)",
    "countryLabel": "Japon",
    "sitelinks": "197"
  },
  {
    "item": "http://www.wikidata.org/entity/Q619",
    "itemLabel": "Nicolas Copernic",
    "birthDate": "1473-02-28T00:00:00Z",
    "deathDate": "1543-06-03T00:00:00Z",
    "description": "astronome polonais, également chanoine, médecin et mathématicien",
    "countryLabel": "Royaume de Pologne",
    "sitelinks": "210"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7328",
    "itemLabel": "Vasco de Gama",
    "birthDate": "1460-01-01T00:00:00Z",
    "deathDate": "1525-01-03T00:00:00Z",
    "description": "grand navigateur portugais (vers 1460-1524)",
    "countryLabel": "royaume de Portugal",
    "sitelinks": "176"
  },
  {
    "item": "http://www.wikidata.org/entity/Q307",
    "itemLabel": "Galilée",
    "birthDate": "1564-02-25T00:00:00Z",
    "deathDate": "1642-01-08T00:00:00Z",
    "description": "physicien, philosophe et astronome italien",
    "countryLabel": "grand-duché de Toscane",
    "sitelinks": "265"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5592",
    "itemLabel": "Michel-Ange Buronarroti",
    "birthDate": "1475-03-15T00:00:00Z",
    "deathDate": "1564-02-28T00:00:00Z",
    "description": "peintre, sculpteur, poète et architecte italien du XVIe siècle",
    "countryLabel": "République florentine",
    "sitelinks": "257"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9381",
    "itemLabel": "Adam Smith",
    "birthDate": "1723-06-01T00:00:00Z",
    "deathDate": "1790-07-17T00:00:00Z",
    "description": "philosophe et économiste écossais (1723-1790)",
    "countryLabel": "royaume de Grande-Bretagne",
    "sitelinks": "215"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9235",
    "itemLabel": "Georg Wilhelm Friedrich Hegel",
    "birthDate": "1770-08-27T00:00:00Z",
    "deathDate": "1831-11-14T00:00:00Z",
    "description": "philosophe allemand",
    "countryLabel": "Royaume du Wurtemberg",
    "sitelinks": "189"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1339",
    "itemLabel": "Jean-Sébastien Bach",
    "birthDate": "1685-03-31T00:00:00Z",
    "deathDate": "1750-07-28T00:00:00Z",
    "description": "claveciniste, organiste et compositeur allemand",
    "countryLabel": "duché de Saxe-Eisenach",
    "sitelinks": "255"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8605",
    "itemLabel": "Simón Bolívar",
    "birthDate": "1783-07-24T00:00:00Z",
    "deathDate": "1830-12-17T00:00:00Z",
    "description": "militaire et homme d'État vénézuélien",
    "countryLabel": "Grande Colombie",
    "sitelinks": "173"
  },
  {
    "item": "http://www.wikidata.org/entity/Q255",
    "itemLabel": "Ludwig van Beethoven",
    "birthDate": "1770-12-16T00:00:00Z",
    "deathDate": "1827-03-26T00:00:00Z",
    "description": "compositeur classique et romantique allemand",
    "countryLabel": "empire d'Autriche",
    "sitelinks": "267"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7207",
    "itemLabel": "Élisabeth Ire",
    "birthDate": "1533-09-17T00:00:00Z",
    "deathDate": "1603-04-03T00:00:00Z",
    "description": "reine d’Angleterre de 1558 à 1603",
    "countryLabel": "royaume d'Angleterre",
    "sitelinks": "179"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5679",
    "itemLabel": "Lord Byron",
    "birthDate": "1788-01-22T00:00:00Z",
    "deathDate": "1824-04-19T00:00:00Z",
    "description": "poète britannique",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "214"
  },
  {
    "item": "http://www.wikidata.org/entity/Q11806",
    "itemLabel": "John Adams",
    "birthDate": "1735-10-30T00:00:00Z",
    "deathDate": "1826-07-04T00:00:00Z",
    "description": "avocat, diplomate et homme d'État américain",
    "countryLabel": "États-Unis",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1399",
    "itemLabel": "Nicolas Machiavel",
    "birthDate": "1469-05-12T00:00:00Z",
    "deathDate": "1527-07-01T00:00:00Z",
    "description": "philosophe florentin",
    "countryLabel": "République florentine",
    "sitelinks": "222"
  },
  {
    "item": "http://www.wikidata.org/entity/Q11806",
    "itemLabel": "John Adams",
    "birthDate": "1735-10-30T00:00:00Z",
    "deathDate": "1826-07-04T00:00:00Z",
    "description": "avocat, diplomate et homme d'État américain",
    "countryLabel": "Treize colonies",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1339",
    "itemLabel": "Jean-Sébastien Bach",
    "birthDate": "1685-03-31T00:00:00Z",
    "deathDate": "1750-07-28T00:00:00Z",
    "description": "claveciniste, organiste et compositeur allemand",
    "countryLabel": "Saint-Empire romain germanique",
    "sitelinks": "255"
  },
  {
    "item": "http://www.wikidata.org/entity/Q34969",
    "itemLabel": "Benjamin Franklin",
    "birthDate": "1706-01-17T00:00:00Z",
    "deathDate": "1790-04-17T00:00:00Z",
    "description": "père fondateur des États-Unis d'Amérique, politicien, écrivain, philosophe, physicien, publiciste et imprimeur américain",
    "countryLabel": "Amérique britannique",
    "sitelinks": "215"
  },
  {
    "item": "http://www.wikidata.org/entity/Q517",
    "itemLabel": "Napoléon Ier",
    "birthDate": "1769-08-15T00:00:00Z",
    "deathDate": "1821-05-05T00:00:00Z",
    "description": "général, Premier consul puis empereur des Français",
    "countryLabel": "France",
    "sitelinks": "282"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7324",
    "itemLabel": "James Cook",
    "birthDate": "1728-10-27T00:00:00Z",
    "deathDate": "1779-02-14T00:00:00Z",
    "description": "navigateur, cartographe et explorateur britannique",
    "countryLabel": "royaume de Grande-Bretagne",
    "sitelinks": "179"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7742",
    "itemLabel": "Louis XIV",
    "birthDate": "1638-09-05T00:00:00Z",
    "deathDate": "1715-09-01T00:00:00Z",
    "description": "roi de France et de Navarre de 1643 à 1715",
    "countryLabel": "royaume de France",
    "sitelinks": "181"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9068",
    "itemLabel": "Voltaire",
    "birthDate": "1694-11-21T00:00:00Z",
    "deathDate": "1778-05-30T00:00:00Z",
    "description": "écrivain et philosophe français",
    "countryLabel": "France",
    "sitelinks": "253"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7328",
    "itemLabel": "Vasco de Gama",
    "birthDate": "1469-01-01T00:00:00Z",
    "deathDate": "1525-01-03T00:00:00Z",
    "description": "grand navigateur portugais (vers 1460-1524)",
    "countryLabel": "royaume de Portugal",
    "sitelinks": "176"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8963",
    "itemLabel": "Johannes Kepler",
    "birthDate": "1572-01-06T00:00:00Z",
    "deathDate": "1630-11-15T00:00:00Z",
    "description": "astronome allemand",
    "countryLabel": "Saint-Empire romain germanique",
    "sitelinks": "181"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5879",
    "itemLabel": "Johann Wolfgang von Goethe",
    "birthDate": "1749-08-28T00:00:00Z",
    "deathDate": "1832-03-22T00:00:00Z",
    "description": "poète, romancier, dramaturge, théoricien de l’art et homme d’État allemand (1749–1832)",
    "countryLabel": "grand-duché de Saxe-Weimar-Eisenach",
    "sitelinks": "273"
  },
  {
    "item": "http://www.wikidata.org/entity/Q6722",
    "itemLabel": "Carl Friedrich Gauss",
    "birthDate": "1777-04-30T00:00:00Z",
    "deathDate": "1855-02-23T00:00:00Z",
    "description": "mathématicien, astronome et physicien allemand (1777-1855)",
    "countryLabel": "Confédération du Rhin",
    "sitelinks": "196"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1290",
    "itemLabel": "Blaise Pascal",
    "birthDate": "1623-06-19T00:00:00Z",
    "deathDate": "1662-08-19T00:00:00Z",
    "description": "mathématicien, physicien, inventeur, écrivain et philosophe chrétien français",
    "countryLabel": "royaume de France",
    "sitelinks": "193"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9191",
    "itemLabel": "René Descartes",
    "birthDate": "1596-03-31T00:00:00Z",
    "deathDate": "1650-02-11T00:00:00Z",
    "description": "philosophe et mathématicien français",
    "countryLabel": "France",
    "sitelinks": "245"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9312",
    "itemLabel": "Emmanuel Kant",
    "birthDate": "1724-04-22T00:00:00Z",
    "deathDate": "1804-02-12T00:00:00Z",
    "description": "philosophe allemand",
    "countryLabel": "royaume de Prusse",
    "sitelinks": "249"
  },
  {
    "item": "http://www.wikidata.org/entity/Q255",
    "itemLabel": "Ludwig van Beethoven",
    "birthDate": "1770-12-16T00:00:00Z",
    "deathDate": "1827-03-26T00:00:00Z",
    "description": "compositeur classique et romantique allemand",
    "countryLabel": "électorat de Cologne",
    "sitelinks": "267"
  },
  {
    "item": "http://www.wikidata.org/entity/Q307",
    "itemLabel": "Galilée",
    "birthDate": "1564-02-25T00:00:00Z",
    "deathDate": "1642-01-08T00:00:00Z",
    "description": "physicien, philosophe et astronome italien",
    "countryLabel": "duché de Florence",
    "sitelinks": "265"
  },
  {
    "item": "http://www.wikidata.org/entity/Q935",
    "itemLabel": "Isaac Newton",
    "birthDate": "1643-01-04T00:00:00Z",
    "deathDate": "1727-03-31T00:00:00Z",
    "description": "philosophe, mathématicien, physicien, alchimiste, astronome et théologien anglais",
    "countryLabel": "royaume de Grande-Bretagne",
    "sitelinks": "303"
  },
  {
    "item": "http://www.wikidata.org/entity/Q37388",
    "itemLabel": "Francis Bacon",
    "birthDate": "1561-02-01T00:00:00Z",
    "deathDate": "1626-04-19T00:00:00Z",
    "description": "homme d’État et philosophe anglais",
    "countryLabel": "royaume d'Angleterre",
    "sitelinks": "185"
  },
  {
    "item": "http://www.wikidata.org/entity/Q762",
    "itemLabel": "Léonard de Vinci",
    "birthDate": "1452-04-24T00:00:00Z",
    "deathDate": "1519-05-12T00:00:00Z",
    "description": "peintre, sculpteur, architecte et ingénieur, théoricien de l'art et chercheur scientifique toscan",
    "countryLabel": "République florentine",
    "sitelinks": "303"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8750",
    "itemLabel": "Michael Faraday",
    "birthDate": "1791-09-22T00:00:00Z",
    "deathDate": "1867-08-25T00:00:00Z",
    "description": "physicien et chimiste britannique",
    "countryLabel": "royaume de Grande-Bretagne",
    "sitelinks": "176"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9215",
    "itemLabel": "Sigmund Freud",
    "birthDate": "1856-05-06T00:00:00Z",
    "deathDate": "1939-09-23T00:00:00Z",
    "description": "neurologue et psychanalyste autrichien",
    "countryLabel": "Troisième Reich",
    "sitelinks": "247"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9358",
    "itemLabel": "Friedrich Nietzsche",
    "birthDate": "1844-10-15T00:00:00Z",
    "deathDate": "1900-08-25T00:00:00Z",
    "description": "philologue, philosophe et poète allemand",
    "countryLabel": "royaume de Prusse",
    "sitelinks": "252"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7199",
    "itemLabel": "Marcel Proust",
    "birthDate": "1871-07-10T00:00:00Z",
    "deathDate": "1922-11-18T00:00:00Z",
    "description": "écrivain, critique et essayiste français",
    "countryLabel": "France",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q12706",
    "itemLabel": "Maxime Gorki",
    "birthDate": "1868-03-28T00:00:00Z",
    "deathDate": "1936-06-18T00:00:00Z",
    "description": "romancier et dramaturge russe",
    "countryLabel": "Union soviétique",
    "sitelinks": "180"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8442",
    "itemLabel": "Otto von Bismarck",
    "birthDate": "1815-04-01T00:00:00Z",
    "deathDate": "1898-07-30T00:00:00Z",
    "description": "homme d'État allemand",
    "countryLabel": "Reich allemand",
    "sitelinks": "216"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7245",
    "itemLabel": "Mark Twain",
    "birthDate": "1835-11-30T00:00:00Z",
    "deathDate": "1910-04-21T00:00:00Z",
    "description": "romancier, journaliste et humoriste américain (1835-1910)",
    "countryLabel": "États-Unis",
    "sitelinks": "244"
  },
  {
    "item": "http://www.wikidata.org/entity/Q91",
    "itemLabel": "Abraham Lincoln",
    "birthDate": "1809-02-12T00:00:00Z",
    "deathDate": "1865-04-15T00:00:00Z",
    "description": "homme d’État américain",
    "countryLabel": "États-Unis",
    "sitelinks": "290"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5582",
    "itemLabel": "Vincent van Gogh",
    "birthDate": "1853-03-30T00:00:00Z",
    "deathDate": "1890-07-29T00:00:00Z",
    "description": "peintre néerlandais",
    "countryLabel": "Royaume des Pays-Bas",
    "sitelinks": "260"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7186",
    "itemLabel": "Marie Curie",
    "birthDate": "1867-11-07T00:00:00Z",
    "deathDate": "1934-07-04T00:00:00Z",
    "description": "physicienne et chimiste polonaise et française",
    "countryLabel": "France",
    "sitelinks": "240"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1268",
    "itemLabel": "Frédéric Chopin",
    "birthDate": "1810-03-01T00:00:00Z",
    "deathDate": "1849-10-17T00:00:00Z",
    "description": "compositeur et pianiste franco-polonais",
    "countryLabel": "royaume du Congrès",
    "sitelinks": "193"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9061",
    "itemLabel": "Karl Marx",
    "birthDate": "1818-05-05T00:00:00Z",
    "deathDate": "1883-03-14T00:00:00Z",
    "description": "philosophe, sociologue et économiste allemand",
    "countryLabel": "apatride",
    "sitelinks": "307"
  },
  {
    "item": "http://www.wikidata.org/entity/Q991",
    "itemLabel": "Fiodor Dostoïevski",
    "birthDate": "1821-11-11T00:00:00Z",
    "deathDate": "1881-02-09T00:00:00Z",
    "description": "écrivain russe",
    "countryLabel": "Empire russe",
    "sitelinks": "245"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7200",
    "itemLabel": "Alexandre Pouchkine",
    "birthDate": "1799-06-06T00:00:00Z",
    "deathDate": "1837-02-10T00:00:00Z",
    "description": "poète, dramaturge et romancier russe",
    "countryLabel": "Empire russe",
    "sitelinks": "237"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9215",
    "itemLabel": "Sigmund Freud",
    "birthDate": "1856-05-06T00:00:00Z",
    "deathDate": "1939-09-23T00:00:00Z",
    "description": "neurologue et psychanalyste autrichien",
    "countryLabel": "empire d'Autriche",
    "sitelinks": "247"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1268",
    "itemLabel": "Frédéric Chopin",
    "birthDate": "1810-03-01T00:00:00Z",
    "deathDate": "1849-10-17T00:00:00Z",
    "description": "compositeur et pianiste franco-polonais",
    "countryLabel": "Deuxième République",
    "sitelinks": "193"
  },
  {
    "item": "http://www.wikidata.org/entity/Q501",
    "itemLabel": "Charles Baudelaire",
    "birthDate": "1821-04-09T00:00:00Z",
    "deathDate": "1867-08-31T00:00:00Z",
    "description": "poète français",
    "countryLabel": "France",
    "sitelinks": "177"
  },
  {
    "item": "http://www.wikidata.org/entity/Q33977",
    "itemLabel": "Jules Verne",
    "birthDate": "1828-02-08T00:00:00Z",
    "deathDate": "1905-03-24T00:00:00Z",
    "description": "écrivain français",
    "countryLabel": "France",
    "sitelinks": "185"
  },
  {
    "item": "http://www.wikidata.org/entity/Q38337",
    "itemLabel": "Alexandre Dumas",
    "birthDate": "1802-07-24T00:00:00Z",
    "deathDate": "1870-12-05T00:00:00Z",
    "description": "écrivain et dramaturge français, père de l'écrivain et dramaturge homonyme",
    "countryLabel": "France",
    "sitelinks": "171"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8750",
    "itemLabel": "Michael Faraday",
    "birthDate": "1791-09-22T00:00:00Z",
    "deathDate": "1867-08-25T00:00:00Z",
    "description": "physicien et chimiste britannique",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "176"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1268",
    "itemLabel": "Frédéric Chopin",
    "birthDate": "1810-03-01T00:00:00Z",
    "deathDate": "1849-10-17T00:00:00Z",
    "description": "compositeur et pianiste franco-polonais",
    "countryLabel": "France",
    "sitelinks": "193"
  },
  {
    "item": "http://www.wikidata.org/entity/Q19185",
    "itemLabel": "George Bernard Shaw",
    "birthDate": "1856-07-26T00:00:00Z",
    "deathDate": "1950-11-02T00:00:00Z",
    "description": "critique musical, dramaturge et scénariste irlandais",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5685",
    "itemLabel": "Anton Tchekhov",
    "birthDate": "1860-01-29T00:00:00Z",
    "deathDate": "1904-07-15T00:00:00Z",
    "description": "écrivain et dramaturge russe",
    "countryLabel": "Empire russe",
    "sitelinks": "235"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7231",
    "itemLabel": "Rosa Luxemburg",
    "birthDate": "1871-03-05T00:00:00Z",
    "deathDate": "1919-01-15T00:00:00Z",
    "description": "militante communiste et révolutionnaire allemande",
    "countryLabel": "Allemagne",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q16867",
    "itemLabel": "Edgar Allan Poe",
    "birthDate": "1809-01-19T00:00:00Z",
    "deathDate": "1849-10-07T00:00:00Z",
    "description": "écrivain américain",
    "countryLabel": "États-Unis",
    "sitelinks": "222"
  },
  {
    "item": "http://www.wikidata.org/entity/Q34787",
    "itemLabel": "Friedrich Engels",
    "birthDate": "1820-11-28T00:00:00Z",
    "deathDate": "1895-08-05T00:00:00Z",
    "description": "philosophe, sociologue et théoricien socialiste allemand",
    "countryLabel": "royaume de Prusse",
    "sitelinks": "195"
  },
  {
    "item": "http://www.wikidata.org/entity/Q19185",
    "itemLabel": "George Bernard Shaw",
    "birthDate": "1856-07-26T00:00:00Z",
    "deathDate": "1950-11-02T00:00:00Z",
    "description": "critique musical, dramaturge et scénariste irlandais",
    "countryLabel": "Royaume-Uni",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q19185",
    "itemLabel": "George Bernard Shaw",
    "birthDate": "1856-07-26T00:00:00Z",
    "deathDate": "1950-11-02T00:00:00Z",
    "description": "critique musical, dramaturge et scénariste irlandais",
    "countryLabel": "Irlande",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5673",
    "itemLabel": "Hans Christian Andersen",
    "birthDate": "1805-04-02T00:00:00Z",
    "deathDate": "1875-08-04T00:00:00Z",
    "description": "romancier, dramaturge, conteur et poète danois (1805-1875)",
    "countryLabel": "Royaume du Danemark",
    "sitelinks": "241"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9215",
    "itemLabel": "Sigmund Freud",
    "birthDate": "1856-05-06T00:00:00Z",
    "deathDate": "1939-09-23T00:00:00Z",
    "description": "neurologue et psychanalyste autrichien",
    "countryLabel": "Cisleithanie",
    "sitelinks": "247"
  },
  {
    "item": "http://www.wikidata.org/entity/Q35610",
    "itemLabel": "Arthur Conan Doyle",
    "birthDate": "1859-05-22T00:00:00Z",
    "deathDate": "1930-07-07T00:00:00Z",
    "description": "écrivain et médecin britannique (écossais), auteur des Sherlock Holmes",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "181"
  },
  {
    "item": "http://www.wikidata.org/entity/Q12706",
    "itemLabel": "Maxime Gorki",
    "birthDate": "1868-03-28T00:00:00Z",
    "deathDate": "1936-06-18T00:00:00Z",
    "description": "romancier et dramaturge russe",
    "countryLabel": "Empire russe",
    "sitelinks": "180"
  },
  {
    "item": "http://www.wikidata.org/entity/Q35610",
    "itemLabel": "Arthur Conan Doyle",
    "birthDate": "1859-05-22T00:00:00Z",
    "deathDate": "1930-07-07T00:00:00Z",
    "description": "écrivain et médecin britannique (écossais), auteur des Sherlock Holmes",
    "countryLabel": "Royaume-Uni",
    "sitelinks": "181"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1001",
    "itemLabel": "Mohandas Karamchand Gandhi",
    "birthDate": "1869-10-02T00:00:00Z",
    "deathDate": "1948-01-30T00:00:00Z",
    "description": "leader politique et religieux indien",
    "countryLabel": "Inde",
    "sitelinks": "280"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9215",
    "itemLabel": "Sigmund Freud",
    "birthDate": "1856-05-06T00:00:00Z",
    "deathDate": "1939-09-23T00:00:00Z",
    "description": "neurologue et psychanalyste autrichien",
    "countryLabel": "Autriche",
    "sitelinks": "247"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7186",
    "itemLabel": "Marie Curie",
    "birthDate": "1867-11-07T00:00:00Z",
    "deathDate": "1934-07-04T00:00:00Z",
    "description": "physicienne et chimiste polonaise et française",
    "countryLabel": "Empire russe",
    "sitelinks": "240"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7241",
    "itemLabel": "Rabîndranâth Tagore",
    "birthDate": "1861-05-07T00:00:00Z",
    "deathDate": "1941-08-07T00:00:00Z",
    "description": "compositeur, écrivain, dramaturge, peintre et philosophe indien (1861-1941)",
    "countryLabel": "Raj britannique",
    "sitelinks": "241"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7317",
    "itemLabel": "Giuseppe Verdi",
    "birthDate": "1813-10-10T00:00:00Z",
    "deathDate": "1901-01-27T00:00:00Z",
    "description": "compositeur italien de l'ère romantique",
    "countryLabel": "royaume d'Italie",
    "sitelinks": "172"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1035",
    "itemLabel": "Charles Darwin",
    "birthDate": "1809-02-12T00:00:00Z",
    "deathDate": "1882-04-19T00:00:00Z",
    "description": "naturaliste anglais, pionnier de la théorie moderne de l'évolution (1809-1882)",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "274"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7315",
    "itemLabel": "Piotr Ilitch Tchaïkovski",
    "birthDate": "1840-05-07T00:00:00Z",
    "deathDate": "1893-11-06T00:00:00Z",
    "description": "compositeur russe",
    "countryLabel": "Empire russe",
    "sitelinks": "187"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8768",
    "itemLabel": "Henry Ford",
    "birthDate": "1863-07-30T00:00:00Z",
    "deathDate": "1947-04-07T00:00:00Z",
    "description": "entrepreneur américain fondateur du constructeur automobile Ford",
    "countryLabel": "États-Unis",
    "sitelinks": "194"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9036",
    "itemLabel": "Nikola Tesla",
    "birthDate": "1856-07-10T00:00:00Z",
    "deathDate": "1943-01-07T00:00:00Z",
    "description": "inventeur et ingénieur serbe naturalisé américain (1856-1943)",
    "countryLabel": "empire d'Autriche",
    "sitelinks": "211"
  },
  {
    "item": "http://www.wikidata.org/entity/Q30875",
    "itemLabel": "Oscar Wilde",
    "birthDate": "1854-10-16T00:00:00Z",
    "deathDate": "1900-11-30T00:00:00Z",
    "description": "écrivain irlandais",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "216"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8442",
    "itemLabel": "Otto von Bismarck",
    "birthDate": "1815-04-01T00:00:00Z",
    "deathDate": "1898-07-30T00:00:00Z",
    "description": "homme d'État allemand",
    "countryLabel": "royaume de Prusse",
    "sitelinks": "216"
  },
  {
    "item": "http://www.wikidata.org/entity/Q33866",
    "itemLabel": "Theodore Roosevelt",
    "birthDate": "1858-10-27T00:00:00Z",
    "deathDate": "1919-01-06T00:00:00Z",
    "description": "homme d'État américain",
    "countryLabel": "États-Unis",
    "sitelinks": "191"
  },
  {
    "item": "http://www.wikidata.org/entity/Q529",
    "itemLabel": "Louis Pasteur",
    "birthDate": "1822-12-27T00:00:00Z",
    "deathDate": "1895-09-28T00:00:00Z",
    "description": "chimiste et biologiste français, fondateur de la microbiologie",
    "countryLabel": "France",
    "sitelinks": "205"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5686",
    "itemLabel": "Charles Dickens",
    "birthDate": "1812-02-07T00:00:00Z",
    "deathDate": "1870-06-09T00:00:00Z",
    "description": "romancier, dramaturge et journaliste anglais (1812–1870)",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "240"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7243",
    "itemLabel": "Léon Tolstoï",
    "birthDate": "1828-09-09T00:00:00Z",
    "deathDate": "1910-11-20T00:00:00Z",
    "description": "écrivain russe, XIXe - début XXe s.",
    "countryLabel": "Empire russe",
    "sitelinks": "273"
  },
  {
    "item": "http://www.wikidata.org/entity/Q30875",
    "itemLabel": "Oscar Wilde",
    "birthDate": "1854-10-16T00:00:00Z",
    "deathDate": "1900-11-30T00:00:00Z",
    "description": "écrivain irlandais",
    "countryLabel": "Royaume-Uni",
    "sitelinks": "216"
  },
  {
    "item": "http://www.wikidata.org/entity/Q30875",
    "itemLabel": "Oscar Wilde",
    "birthDate": "1854-10-16T00:00:00Z",
    "deathDate": "1900-11-30T00:00:00Z",
    "description": "écrivain irlandais",
    "countryLabel": "France",
    "sitelinks": "216"
  },
  {
    "item": "http://www.wikidata.org/entity/Q30875",
    "itemLabel": "Oscar Wilde",
    "birthDate": "1854-10-16T00:00:00Z",
    "deathDate": "1900-11-30T00:00:00Z",
    "description": "écrivain irlandais",
    "countryLabel": "Irlande",
    "sitelinks": "216"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5589",
    "itemLabel": "Henri Matisse",
    "birthDate": "1869-12-31T00:00:00Z",
    "deathDate": "1954-11-03T00:00:00Z",
    "description": "peintre, dessinateur, sculpteur et graveur français",
    "countryLabel": "France",
    "sitelinks": "175"
  },
  {
    "item": "http://www.wikidata.org/entity/Q8743",
    "itemLabel": "Thomas Edison",
    "birthDate": "1847-02-11T00:00:00Z",
    "deathDate": "1931-10-18T00:00:00Z",
    "description": "inventeur, scientifique et industriel américain (1847–1931)",
    "countryLabel": "États-Unis",
    "sitelinks": "249"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1268",
    "itemLabel": "Frédéric Chopin",
    "birthDate": "1810-03-01T00:00:00Z",
    "deathDate": "1849-10-17T00:00:00Z",
    "description": "compositeur et pianiste franco-polonais",
    "countryLabel": "Empire russe",
    "sitelinks": "193"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7186",
    "itemLabel": "Marie Curie",
    "birthDate": "1867-11-07T00:00:00Z",
    "deathDate": "1934-07-04T00:00:00Z",
    "description": "physicienne et chimiste polonaise et française",
    "countryLabel": "Deuxième République de Pologne",
    "sitelinks": "240"
  },
  {
    "item": "http://www.wikidata.org/entity/Q7231",
    "itemLabel": "Rosa Luxemburg",
    "birthDate": "1871-03-05T00:00:00Z",
    "deathDate": "1919-01-15T00:00:00Z",
    "description": "militante communiste et révolutionnaire allemande",
    "countryLabel": "Empire russe",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1268",
    "itemLabel": "Frédéric Chopin",
    "birthDate": "1810-03-01T00:00:00Z",
    "deathDate": "1849-10-17T00:00:00Z",
    "description": "compositeur et pianiste franco-polonais",
    "countryLabel": "duché de Varsovie",
    "sitelinks": "193"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1394",
    "itemLabel": "Lénine",
    "birthDate": "1870-04-22T00:00:00Z",
    "deathDate": "1924-01-21T00:00:00Z",
    "description": "révolutionnaire et homme d'État russe puis soviétique",
    "countryLabel": "Union soviétique",
    "sitelinks": "292"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9061",
    "itemLabel": "Karl Marx",
    "birthDate": "1818-05-05T00:00:00Z",
    "deathDate": "1883-03-14T00:00:00Z",
    "description": "philosophe, sociologue et économiste allemand",
    "countryLabel": "royaume de Prusse",
    "sitelinks": "307"
  },
  {
    "item": "http://www.wikidata.org/entity/Q535",
    "itemLabel": "Victor Hugo",
    "birthDate": "1802-02-26T00:00:00Z",
    "deathDate": "1885-05-22T00:00:00Z",
    "description": "romancier, poète, dramaturge, dessinateur et politicien français",
    "countryLabel": "France",
    "sitelinks": "261"
  },
  {
    "item": "http://www.wikidata.org/entity/Q34787",
    "itemLabel": "Friedrich Engels",
    "birthDate": "1820-11-28T00:00:00Z",
    "deathDate": "1895-08-05T00:00:00Z",
    "description": "philosophe, sociologue et théoricien socialiste allemand",
    "countryLabel": "Royaume-Uni",
    "sitelinks": "195"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9106",
    "itemLabel": "Dmitri Mendeleïev",
    "birthDate": "1834-02-08T00:00:00Z",
    "deathDate": "1907-02-02T00:00:00Z",
    "description": "chimiste russe",
    "countryLabel": "Empire russe",
    "sitelinks": "177"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9439",
    "itemLabel": "Victoria",
    "birthDate": "1819-05-24T00:00:00Z",
    "deathDate": "1901-01-22T00:00:00Z",
    "description": "reine du Royaume-Uni entre 1837 et 1901",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "172"
  },
  {
    "item": "http://www.wikidata.org/entity/Q4605",
    "itemLabel": "Sarah Bernhardt",
    "birthDate": "1844-10-23T00:00:00Z",
    "deathDate": "1923-03-26T00:00:00Z",
    "description": "peintre, sculptrice et comédienne française",
    "countryLabel": "France",
    "sitelinks": "191"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9711",
    "itemLabel": "Honoré de Balzac",
    "birthDate": "1799-05-20T00:00:00Z",
    "deathDate": "1850-08-18T00:00:00Z",
    "description": "romancier, critique littéraire, essayiste, journaliste et écrivain français",
    "countryLabel": "France",
    "sitelinks": "172"
  },
  {
    "item": "http://www.wikidata.org/entity/Q34743",
    "itemLabel": "Rudyard Kipling",
    "birthDate": "1865-12-30T00:00:00Z",
    "deathDate": "1936-01-18T00:00:00Z",
    "description": "écrivain et journaliste britannique (1865-1936)",
    "countryLabel": "Royaume-Uni de Grande-Bretagne et d'Irlande",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9021",
    "itemLabel": "Max Planck",
    "birthDate": "1858-04-23T00:00:00Z",
    "deathDate": "1947-10-04T00:00:00Z",
    "description": "physicien allemand",
    "countryLabel": "Reich allemand",
    "sitelinks": "182"
  },
  {
    "item": "http://www.wikidata.org/entity/Q34296",
    "itemLabel": "Woodrow Wilson",
    "birthDate": "1856-12-28T00:00:00Z",
    "deathDate": "1924-02-03T00:00:00Z",
    "description": "homme d'État américain",
    "countryLabel": "États-Unis",
    "sitelinks": "188"
  },
  {
    "item": "http://www.wikidata.org/entity/Q23810",
    "itemLabel": "Alfred Nobel",
    "birthDate": "1833-10-21T00:00:00Z",
    "deathDate": "1896-12-10T00:00:00Z",
    "description": "chimiste, industriel et fabricant d'armes suédois",
    "countryLabel": "Suède",
    "sitelinks": "191"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9036",
    "itemLabel": "Nikola Tesla",
    "birthDate": "1856-07-10T00:00:00Z",
    "deathDate": "1943-01-07T00:00:00Z",
    "description": "inventeur et ingénieur serbe naturalisé américain (1856-1943)",
    "countryLabel": "États-Unis",
    "sitelinks": "211"
  },
  {
    "item": "http://www.wikidata.org/entity/Q9036",
    "itemLabel": "Nikola Tesla",
    "birthDate": "1856-07-10T00:00:00Z",
    "deathDate": "1943-01-07T00:00:00Z",
    "description": "inventeur et ingénieur serbe naturalisé américain (1856-1943)",
    "countryLabel": "Hongrie",
    "sitelinks": "211"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1511",
    "itemLabel": "Richard Wagner",
    "birthDate": "1813-05-22T00:00:00Z",
    "deathDate": "1883-02-13T00:00:00Z",
    "description": "compositeur, directeur de théâtre, écrivain, chef d'orchestre et polémiste allemand de la période romantique",
    "countryLabel": "royaume de Saxe",
    "sitelinks": "200"
  },
  {
    "item": "http://www.wikidata.org/entity/Q34743",
    "itemLabel": "Rudyard Kipling",
    "birthDate": "1865-12-30T00:00:00Z",
    "deathDate": "1936-01-18T00:00:00Z",
    "description": "écrivain et journaliste britannique (1865-1936)",
    "countryLabel": "Royaume-Uni",
    "sitelinks": "184"
  },
  {
    "item": "http://www.wikidata.org/entity/Q5604",
    "itemLabel": "Frank Lloyd Wright",
    "birthDate": "1867-06-08T00:00:00Z",
    "deathDate": "1959-04-09T00:00:00Z",
    "description": "architecte et concepteur américain (1867-1959)",
    "countryLabel": "États-Unis",
    "sitelinks": "174"
  },
  {
    "item": "http://www.wikidata.org/entity/Q937",
    "itemLabel": "Albert Einstein",
    "birthDate": "1879-03-14T00:00:00Z",
    "deathDate": "1955-04-18T00:00:00Z",
    "description": "physicien helvético-américain d'origine allemande",
    "countryLabel": "Cisleithanie",
    "sitelinks": "318"
  },
  {
    "item": "http://www.wikidata.org/entity/Q33391",
    "itemLabel": "Léon Trotski",
    "birthDate": "1879-11-07T00:00:00Z",
    "deathDate": "1940-08-21T00:00:00Z",
    "description": "révolutionnaire et homme politique russo-soviétique",
    "countryLabel": "Russie soviétique",
    "sitelinks": "178"
  },
  {
    "item": "http://www.wikidata.org/entity/Q1047",
    "itemLabel": "Jawaharlal Nehru",
    "birthDate": "1889-11-14T00:00:00Z",
    "deathDate": "1964-05-27T00:00:00Z",
    "description": "homme d’État indien",
    "countryLabel": "Raj britannique",
    "sitelinks": "189"
  },
  {
    "item": "http://www.wikidata.org/entity/Q855",
    "itemLabel": "Joseph Staline",
    "birthDate": "1878-12-18T00:00:00Z",
    "deathDate": "1953-03-05T00:00:00Z",
    "description": "dictateur et homme d'État soviétique",
    "countryLabel": "Empire russe",
    "sitelinks": "276"
  }
]
